import notification from '../../services/notification-service'
import OrderService from '../../services/order-service'
import router from '../../router/index.js'
import i18n from './../../i18n'

// initial state
const state = {
  items: [],
  
  loadingCheckout: false,
  errorInCheckout: false
}

// getters
const getters = {
}

// actions
const actions = {
  retrieveShoppingBasket({ commit }) {
    const items = localStorage.getItem('ret-shopping-cart')
    if (items) commit('setCartItems', JSON.parse(items))
  },

  updateOrAddCart({ commit }, item) {
    const cartItem = state.items.find(i => i.product.id === item.product.id)
    cartItem ? commit('updateProductInCart', {product: cartItem.product, quantity: item.quantity}) : commit('addroductToCart', {product: item.product, quantity: item.quantity})
    commit('setCartItemsInStorage')
    notification.notify(i18n.t('notifications.succeeded'), i18n.t('notifications.productAdded', {id: item.product.id, quantity: item.quantity}), "success")
  },
  
  setProductQuantity({commit}, item) {
    commit('setQuantityInCart', item)
    commit('setCartItemsInStorage')
  },
  
  deleteProduct({commit}, productId) {
    commit('deleteProductById', productId)
    commit('setCartItemsInStorage')
  },
  
  async sendOrder({commit}, order) {
    commit('setLoadingCheckout', true)
    commit('setErrorInCheckout', false)
    
    const response = await OrderService.sendOrder(order.cartItems, order.reference, order.commentary, order.totalPrice)
    
    if (response.error) { 
      notification.notify(i18n.t('notifications.oops'), response.readable, "error")
      commit('setErrorInCheckout', true)
    } else {
      router.push({ name: 'Success' })
      commit('setCartItems', [])
      commit('setCartItemsInStorage')
    }
    commit('setLoadingCheckout', false)
    
  }
}

// mutations
const mutations = {
  addroductToCart (state, item) {
    state.items.push(item)
  },

  updateProductInCart (state, item) {
    const current = state.items.find(i => i.product.id == item.product.id)
    current.quantity += item.quantity
  },

  setQuantityInCart(state, item) {
    const current = state.items.find(i => i.product.id == item.product.id)
    current.quantity = item.quantity
  },

  deleteProductById(state, id) {
    const current = state.items.find(i => i.product.id == id)
    state.items.splice(state.items.indexOf(current), 1)
  },

  setCartItemsInStorage() {
    localStorage.setItem('ret-shopping-cart', JSON.stringify(state.items))
  },

  setCartItems (state, items) {
    state.items = items
  },

  setLoadingCheckout (state, isLoading) {
    state.loadingCheckout = isLoading
  },

  setErrorInCheckout (state, isError) {
    state.errorInCheckout = isError
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}